<template>
    <CRow>
        <CCol col>
            <div class="form-row">
                <div class="form-group col-md-3  d-flex justify-content-center input-group">
                    <ejs-dropdownlist ref='dplVolumeUnits' id="VolumeUnits" name="volumeUnits" floatLabelType='Auto' :dataSource='volumeUnits' :fields="{text: 'name', value: 'id' }" :index='typeIndex' placeholder="Volume Units" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3  d-flex justify-content-center input-group">
                    <ejs-dropdownlist ref='dplCurrencyM2M' id="currencyM2M" name="currency" v-model="currencyId" :dataSource='currenciesM2M' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3  d-flex justify-content-center input-group">
                    <ejs-dropdownlist ref='dplIncludeDefaultMechanism' id="includeDefaultMechId" name="includeDefaultMechName" v-model="includeDefaultMechId" :dataSource='includeDefaultMechanism' :fields="{text: 'name', value: 'id' }" placeholder="Default Mechanism" floatLabelType='Auto' :validationRules="requiredRules" :showClearButton='true'></ejs-dropdownlist>
                </div>
                <div class="form-row form-group justify-content-end ">
                    <ejs-button v-if="canSave" style="margin-right: 10px; margin-left: 10px" cssClass="e-primary c-report" v-on:click.native='runReport'>Create Report</ejs-button>
                </div>
            </div>
           
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="groupData" :commandClick='commandClick' :allowPaging="true" :allowFiltering='true'
                          :allowResizing='true' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true'
                          :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings'
                          :actionComplete='actionComplete' :actionBegin="actionBegin" :actionFailure="actionFailure" :filterSettings='filterOptions' 
                          :enablePersistence="true" :query='query' :toolbarClick='toolbarClick' width="100%" height="100%" :queryCellInfo='queryCellInfo'>
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' width="50" :visible='false'></e-column>
                        <e-column field='createdDate' headerText='Run on' width="150" :validationRules="requiredRules" :format='dateFormatOptions' type='date'></e-column>
                        <e-column field='name' headerText='Report Name' width="200" :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='currency' headerText='Currency Unit' width="100" type="string" :validationRules="requiredRules"></e-column>
                        <e-column field='volume' headerText='Volume unit' width="100" type="string"></e-column>
                        <e-column field='defaultMechanismIncluded' headerText='Include Default Mechanism' width="100" type="string"></e-column>
                        <!--<e-column field='createdBy' headerText='Created By' :validationRules="requiredRules" type="string"></e-column>-->
                        <e-column headerText='Actions' width='120' textAlign='Center' :template='cTemplate'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { Query } from '@syncfusion/ej2-data';
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import Router from 'vue-router'
    import store from '../../store';
    import router from '../../router';
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import moment from 'moment';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(Router)
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    Vue.use(GridPlugin);
    let DialogConfirmAdminDelete = undefined;

    export default {
        name: 'AdminReportForm',
        components: {
        },
        data() {
            return {
                query: new Query().addParams("latest", "true"),
                store: store,
                router: router,
                groupData: SyncHelper.getDataManager("AdminReport"),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy hh:mm a' },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowAdding: false,
                    allowDeleting: store.state.permissions["Permissions.AdminReports.Delete"],
                    mode: 'Dialog'
                }, 
                filterOptions: gridOptions.filterSettings,
                toolbar: [{ text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteAdminReport' }],
                currencyId: null,
                includeDefaultMechId: null,
                includeDefaultMechanism: [
                    { "name": "Include Default Mechanism", "id": 1 },
                    { "name": "Exclude Default Mechanism", "id": 2 },
                ],
                allowFiltering: true,
                canSave: store.state.permissions["Permissions.AdminReports.Create"],
                requiredRules: { required: true, maxLength: 256 },
                editparams: { params: { popupHeight: '300px' } },
                commands: [{ buttonOption: { cssClass: 'e-primary', content: 'Export' } }],  
                cTemplate: function () {
                    return {
                        template: Vue.component('columnTemplate', {
                            template: `<ejs-button cssClass='secondary' v-on:click.native="click(data)">Download</ejs-button>`,// <a :href="this.data.reportUrl" cssClass='e-block e-success'   download> Download</a>
                            data: function () {
                                return { 
                                    data: {}
                                }
                            },
                            methods: {
                                click: function (args) {
                                    
                                    showSpinner(document.getElementById('mainSpinner'));
                                    apis.protectedApi(`${urls.apiBaseUrl}AdminReport/getReport/${args.id}`,
                                        { responseType: 'blob' }).then(
                                            it => {
                                                var blob = new Blob([it.data], { type: 'application/' + it.headers['content-type'] })
                                                var downloadElement = document.createElement('a')
                                                var href = window.URL.createObjectURL(blob) // Create a downloaded link
                                                downloadElement.href = href
                                                downloadElement.download = args.name + "-" + moment().format('DD/MM/YYYY HH:mm') + ".xlsx"; // filename after download
                                                document.body.appendChild(downloadElement)
                                                downloadElement.click() // Click to download
                                                document.body.removeChild(downloadElement)
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }).catch(
                                                response => {
                                                    var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                                    gridOptions.errorAlert("Error: " + message);
                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                }
                                            );
                                }
                            }
                        })
                    }
                }
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading',

            });
        },
        methods: {
            commandClick: function (args) {
                var templateId = args.rowData.id;
                if (args.commandColumn.buttonOption.content == "Export") {
                    this.runReport(templateId, this.$refs.grid);
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            toolbarClick(args) {
               
                if (args.item.properties.id === 'ExcelExport') {
                    gridOptions.excelExport(args, "Admin Reports.xlsx", this.$refs);
                }
                if (args.item.id === "DeleteAdminReport") {
                    var selectedrep = this.$refs.grid.getSelectedRecords();
                    if (selectedrep && selectedrep.length > 0) {
                        DialogConfirmAdminDelete = DialogUtility.confirm({
                            title: 'Alert Dialog',
                            content: "Are you sure you want to delete this report?",
                            position: { X: 700, Y: 200 },
                            okButton: { text: 'OK', click: this.deleteAdminReport },
                            cancelButton: { text: 'Cancel', click: this.cancelDeleteAdminReport },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
            },
            runReport: (args) => {

                var currency = document.getElementById("currencyM2M").value;
                var volume = document.getElementById("VolumeUnits").value;
                var defaulMText = document.getElementById("includeDefaultMechId").value;
                var defaultM = document.getElementById("includeDefaultMechId").value.includes("Include") ? true : false;

                if (currency == "" || volume == "" || defaulMText == "") {
                    gridOptions.errorAlert("Volume Unit, Currency or Default Mechanism are missing.");
                    return;
                }
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}AdminReport/runAdminReport?currency=${currency}&volume=${volume}&defaultM=${defaultM}`).then(it => {
                    gridOptions.infoAlert("Report set to execute. When execution is done the report will be listed under available reports");
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            },
            deleteAdminReport: function () {
                var selectedrep = this.$refs.grid.getSelectedRecords();
                if (selectedrep) {
                    apis.protectedApi.delete(`AdminReport/${selectedrep[0].id}`)
                        .then(response => {
                            let message = { title: 'Success!', content: 'Record is deleted successfully', cssClass: 'e-toast-success' };
                            this.$root.$emit('showToast', message);
                            this.$refs.grid.refresh();
                        }).catch(e => {
                            DialogUtility.alert({
                                title: 'Alert Dialog',
                                content: e.response.data.message,
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' },
                                zIndex: 1100
                            });
                        });
                }
                DialogConfirmAdminDelete.hide();
            },
            cancelDeleteAdminReport: function () {
                DialogConfirmAdminDelete.hide();
            },
            excelExportComplete(args) {
             
                this.$refs.grid.hideSpinner();
                hideSpinner(document.getElementById('mainSpinner'));
            },

            actionComplete(args) {
               gridOptions.actionComplete(args, this.$refs);
            },
            actionBegin(args) {
               
                gridOptions.actionBegin(args);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            queryCellInfo(args) {
                if (args.column.field == "defaultMechanismIncluded") {
                    args.cell.textContent = args.data.defaultMechanismIncluded == true ? "Yes" : "No";
                }
                
            },
            fixDateOffset: function(date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return moment(date).format('DD/MM/YYYY hh:mm A');
            },
        },
        computed: {
            currenciesM2M() {
                return SyncHelper.getDataManager("utils/curenciesForReports");
            },
            volumeUnits() {
                return SyncHelper.getDataManager("utils/volumeUnits"); 
            }

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        }
    };

</script>
<style>

    .c-report {
        padding: 4px 4px 4px 4px;
        height: 31px;
        margin-top: 24px;
    }
</style>
